module.exports = "/images/group_events_white.png?f268ec787a50d9d386dbfec2ba9054c8";